import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {ConfigurationsActionCreators} from "../../../../actions/actionCreators";
import {GROUP_TYPE} from "../../../../reducers/editingConfiguration.reducer";
import {configurationsStoreSelectors} from "../../../../store/store";
import JackpotGameGroups from "./GameGroups/JackpotGameGroups.component";
import "./GroupsConfigurationSection.component.scss";
import TerminalGroups from "./TerminalGroups/TerminalGroups.component";
import SectionHeader from "./SectionHeader/SectionHeader.component";
import {ConfigurationsActionTypes} from "../../../../actions/actionTypes";

const useFetchGamesEffect = () => {
    const dispatch = useDispatch();
    const currentSubsidiaryId = useSelector(
        configurationsStoreSelectors.editingConfiguration
    );
    const gameBundles = useSelector(
        configurationsStoreSelectors.gameBundles
    );
    useEffect(() => {
        //if(gameBundles.length === 0) {
        dispatch(
            ConfigurationsActionCreators.getGameBundles({
                subsidiary: currentSubsidiaryId.subsidiary.id
            })
        );
        //}

        dispatch(
            ConfigurationsActionCreators.configSectionVisited(
                ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG
            )
        );
    }, []);
};

const useSelectGroupTypeEffect = () => {
    const dispatch = useDispatch();
    const currentSelectedGroupType = useSelector(
        configurationsStoreSelectors.getSelectedGroupType
    );

    const progressivesConfigs = useSelector(configurationsStoreSelectors.progressivesConfig);

    const [selectedGroupType, setSelectedGroupType] = useState(
        currentSelectedGroupType
    );

    const handleSelectGroupType = (groupTypes: string[]) => {
        if (groupTypes.length === 0) {
            setSelectedGroupType(null);
        } else if (groupTypes.length > 1) {
            const newType = groupTypes.filter(
                groupType => groupType !== selectedGroupType
            )[0];
            setSelectedGroupType(newType as GROUP_TYPE);
        } else {
            setSelectedGroupType(groupTypes[0] as GROUP_TYPE);
        }
    };

    useEffect(() => {
        if (currentSelectedGroupType !== selectedGroupType) {
            dispatch(
                ConfigurationsActionCreators.selectGroupType(selectedGroupType)
            );

            dispatch(
                ConfigurationsActionCreators.updateProgressivesConfig({
                    config: progressivesConfigs,
                    isValid: false,
                    groupType: selectedGroupType
                })
            );
        }

        //if (selectedGroupType == GROUP_TYPE.GAME) {
        dispatch(
            ConfigurationsActionCreators.updateGroupsConfig({
                config: [],
                isValid: false
            })
        );
        /*} else if (!selectedGroupType) {
            dispatch(
                ConfigurationsActionCreators.updateGroupsConfig({
                    config: [],
                    isValid: false
                })
            );
        }*/
    }, [selectedGroupType]);

    useEffect(() => {
        return () => {
            dispatch(
                ConfigurationsActionCreators.clearGroupTypes(selectedGroupType)
            );
        };
    }, []);

    return {
        selectedGroupType,
        handleSelectGroupType
    };
};

const GroupsConfigurationSection = () => {
    useFetchGamesEffect();
    const {selectedGroupType, handleSelectGroupType} =
        useSelectGroupTypeEffect();

    const editingConfiguration = useSelector(
        configurationsStoreSelectors.editingConfiguration
    );

    const country_code = editingConfiguration.subsidiary.country.code
    if (
        editingConfiguration.settings.settings.settings !== null &&
        editingConfiguration.settings.settings.settings.game_types.length == 0
    ) {
        return (
            <div id="GroupsConfigurationSection">
                <div className="row">
                    <div className="empty-prize-types">
                        <p>
                            <i className="icon-exclamation-circle-light"></i>A
                            game type must be selected in General Settings to be
                            able to configure jackpot groups in this server.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="GroupsConfigurationSection">
            {country_code !== "BR" && (
                <div className="row">
                    <div className="warning-unused-groups">
                        <p>
                            <i className="icon-exclamation-circle-light"></i>All
                            groups created but not assigned to a progressive or
                            special prize will not be saved when submiting
                            configuration.
                        </p>
                    </div>
                </div>
            )}
            <SectionHeader
                chosenType={selectedGroupType}
                onSelectItem={handleSelectGroupType}
            />
            {selectedGroupType === GROUP_TYPE.TERMINAL && parseFloat(editingConfiguration['system_server_version']) < 1.8 && country_code !== "BR" && (
                <div className="row">
                    <div className="warning-unused-groups">
                        <p style={{textAlign: "left"}}>
                            <i className="icon-exclamation-circle-light"></i>
                            <b style={{marginRight: "15px"}}>
                                Attention
                            </b>{" "}
                            After applying a configuration with terminal groups
                            you will not be allowed to update the server to a
                            configuration with Game Groups.
                        </p>
                    </div>
                </div>
            )}
            {selectedGroupType === GROUP_TYPE.TERMINAL && (
                <React.Fragment>
                    <TerminalGroups/>
                </React.Fragment>
            )}
            {selectedGroupType === GROUP_TYPE.GAME && (
                <React.Fragment>
                    <JackpotGameGroups/>
                </React.Fragment>
            )}
        </div>
    );
};

export default GroupsConfigurationSection;
